import React from 'react';

import Nav from '../components/Nav';
import Header from '../components/Header';
import Banner from '../components/Banner';
import OurServices from '../components/OurServices';
import WhyChoseUs from '../components/WhyChoseUs';
import CaseStudies from '../components/CaseStudies';
import TechnicalAnalysis from '../components/TechnicalAnalysis';
import OurClientSays from '../components/OurClientSays';
import KeepInTouch from '../components/KeepInTouch';
import Footer from '../components/Footer';

function Home() {
  return (
    <>
    <Nav />
    <Header />
    <Banner />

    <OurServices />

    <WhyChoseUs />
    
    <CaseStudies />
    
    <TechnicalAnalysis />

    <OurClientSays />

    <KeepInTouch />

    <Footer />

    </>
  )
}

export default Home